import Card from "../UI/Card";
import style from "./About.module.css";
import avatar from "../../Assets/Images/hey.png";
import { useInView } from "react-intersection-observer";
import SectionHeader from "../UI/SectionHeader";

const About = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: "40%",
  });
  return (
    <div id="me" ref={ref} className={inView ? style.animation : ""}>
      <Card className={style.card}>
        <div className={style["avatar-container"]}>
          <img src={avatar} alt="myavarta" />
        </div>
        <SectionHeader span="A" title="ABOUT" titleSpan="ME" />
        <div className={style.description}>
          <p>
            Seeking FrontEnd engineering roles, to apply my thorough knowledge
            of programming frameworks and developmental softwares to build
            Interfaces that help everyday people optimize their daily task. I’m
            interested in roles that involve critical thinking to design and
            implement interfaces that comform to global standards whilst
            maintaining best practices in my code bases . I’m even more peculiar
            about roles in HealthTech, coupling my knowledge of medicine with
            FrontEnd Engineer has also been a dream i hope to achieve.
          </p>
          <p>
            Growing up as a young Nigerian on the streets of Lagos,Nigeria; I
            had also been passionate about technological innovations and even
            though I ended up pursuing a degree in the Health Sciences,I look up
            to great software developers who have also pursued degrees in the
            Health science: people like Dr Angela YU,Dr Bamire Kuti etc. I hope
            to merge my passion in these two great fields to create technologies
            that help people globally. I'm open to roles and oppurtunies that
            help me navigate this dream . It's Nice to have you here, Again I'm
            Moyosore J Olaojo; FrontEnd Engineer and Medical Student and I look
            forward to working with you.
          </p>
        </div>
      </Card>
    </div>
  );
};
export default About;
